import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Table from "../../components/Table/Table";
import {request} from "../../helper/APIUtils";
import {hasUserRight, prefixTypeName, showAxiosError} from "../../helper/helper";
import PrefixCodeModal from "./PrefixCodeModal";
import NavBarKS from "../../components/NavBarKS";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import {VirtualHost} from "../../constants";
import StickButton from "../../components/StickButton";
import Select from "../../local_node_modules/react-select";
import Alert from "react-s-alert";

class PrefixCode extends Component {

    constructor(props) {
        super(props);

        this.state = {
            prefixCodes: [],
            branchBasedPrefixList: [],
            newPrefixList: [],
            selectedPrefix: null,
            confirmDeleteModal: false,
            loading: false,
            loading2: false,
            total: 0,
            total2: 0,
            page: 0,
            page2: 0,
            size: 10,
            size2: 10,
            manual: false,
            addPrefixModal: false,
            selectedType: 'PrefixCode',
            branchList: [],
            branchPrefix: {
                branchIndex: null,
                prefixType: null,
                prefixIndex: null
            },
            prefixList: undefined,
            branchBasedPrefixCode: false,
            activeTab: "generalprefix",
            confirmActivePassiveModal: false,
            activePassiveAction: null,
            loadingProcess: false
        };

        this.handleActivePassive = this.handleActivePassive.bind(this);
        this.confirmActivePassive = this.confirmActivePassive.bind(this);
    }

    componentDidMount() {
        this.fetchCustomerAndBranches();
    }

    fetchCustomerAndBranches = async () => {
        let customerId = this.props.currentUser.customerId;
        let cutomerParams = {
            url: `/customer/get/${customerId}`,
            method: "post",
        };
        let params = {
            url: `/customerBranch/fetchCustomerBranches`,
            method: "get",
        };
        try {
            const cResponse = await request(cutomerParams);
            if (cResponse && cResponse.data && cResponse.data.customer && cResponse.data.customer.branchBasedPrefixCode) {
                this.setState({branchBasedPrefixCode: true})
            }
            const response = await request(params);
            this.setState({branchList: response.data})
        } catch (error) {
            showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
        }
    }

    getPrefix = async (prefixType) => {
        const {newPrefixList, branchPrefix} = this.state
        let params = {
            url: `/prefixCode/getPrefixCodesByType?page=0&size=100`,
            method: "post",
            data: prefixType
        };
        try {
            const response = await request(params);
            let prefixList = response.data.content;
            if (branchPrefix.branchIndex != null && newPrefixList && newPrefixList.length > 0) {
                prefixList = prefixList.filter(item => {
                    return newPrefixList.find(o => o.prefixCodeKey === item.key) == null
                })
            }
            this.setState({prefixList});
        } catch (error) {
            showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
        }
    }

    searchInArray = (arrayList, column, value) => {
        let item = arrayList.filter(o => o[column] === value);
        return item;
    }

    checkIsValidBranchPrefix = () => {
        const {branchPrefix, prefixList, branchList, branchBasedPrefixList} = this.state
        let keyFiltered;
        let branchFiltered = this.searchInArray(branchBasedPrefixList, "branchName", branchList[branchPrefix.branchIndex].branchName)
        if (branchFiltered != null) {
            let typeFiltered = this.searchInArray(branchFiltered, "prefixCodeType", branchPrefix.prefixType);
            if (typeFiltered != null) {
                keyFiltered = this.searchInArray(typeFiltered, "prefixCodeKey", prefixList[branchPrefix.prefixIndex].key);
            }
        }
        if (keyFiltered.length > 0) return false
        return true;
    }
    saveBranchPrefix = async () => {
        const {branchPrefix, prefixList, branchList} = this.state
        let isValid = this.checkIsValidBranchPrefix();
        if (!isValid) {
            showAxiosError({message: "Bu kayıt zaten var"});
            return;
        }
        let params = {
            url: `/customerBranchPrefix/save`,
            method: "post",
            data: {
                prefixCode: prefixList[branchPrefix.prefixIndex],
                prefixType: branchPrefix.prefixType,
                customerBranch: branchList[branchPrefix.branchIndex],
            }
        };
        this.setState({loading: true});
        try {
            const response = await request(params);
            let prefixList = response.data.content;
            const {page2, size2} = this.state
            this.setState({loading: false, prefixList});
            Alert.success("Başarılı bir şekilde kaydedildi.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000,
                html: false
            });
            this.listBranchBasedPrefixList(undefined, undefined, page2, size2);
        } catch (error) {
            showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
        }
    }

    listPrefixCodes = (accessor, direction, page, size) => {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '';
        let params = {
            url: '/prefixCode/getPrefixCodes?page=' + page + '&size=' + size + sortStr,
            method: "post",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        self.props.reload(true);
        request(params)
            .then(function (response) {
                let prefixCodes = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    prefixCodes,
                    loading: false,
                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }
    listBranchBasedPrefixList = async (accessor, direction, page, size) => {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '';
        let params = {
            url: '/customerBranchPrefix/fetchAll?page=' + page + '&size=' + size + sortStr,
            method: "post",
        };
        self.setState({loading2: true, manual: self.manual === true ? false : self.manual});
        self.props.reload(true);
        try {
            const response = await request(params);
            let branchBasedPrefixList = response.data.content;
            let {branchPrefix, branchList} = this.state;
            let newPrefixList = [];

            if (branchPrefix.branchIndex != null && branchPrefix.prefixType != null) {
                newPrefixList = branchBasedPrefixList.filter(item => {
                    return item.branchName === branchList[branchPrefix.branchIndex].branchName
                }).filter(item => {
                    return item.prefixCodeType === branchPrefix.prefixType
                })
            } else {
                newPrefixList = branchBasedPrefixList;
            }

            self.setState({
                page2: page,
                size2: size,
                total2: response.data.totalElements,
                branchBasedPrefixList,
                newPrefixList
            });
            self.props.reload(false);
        } catch (error) {
            self.props.reload(false);
            showAxiosError(error);
        }
        self.setState({loading2: false});

    }

    confirmDelete(item, type) {
        this.setState({
            selectedPrefix: item,
            confirmDeleteModal: true,
            deleteType: type
        })
    }

    handleDelete = async () => {
        const {deleteType, page, size, page2, size2} = this.state
        let params;
        if (deleteType === 'mainPrefix') {
            params = {
                url: '/prefixCode/deletePrefix',
                method: "post",
                data: this.state.selectedPrefix
            };
        } else if (deleteType === "customerBranchPrefix") {
            params = {
                url: '/customerBranchPrefix/delete',
                method: "post",
                data: this.state.selectedPrefix.recordId
            };
        }

        this.setState({loading: true, manual: this.manual === true ? false : this.manual});
        try {
            const response = await request(params);
            this.setState({
                manual: true,
                selectedPrefix: null,
                confirmDeleteModal: false
            });
            if (deleteType === 'mainPrefix') {
                this.listPrefixCodes(undefined, undefined, page, size);
                this.listBranchBasedPrefixList(undefined, undefined, page2, size2);
            } else if (deleteType === "customerBranchPrefix") {
                this.listBranchBasedPrefixList(undefined, undefined, page2, size2);
            }
        } catch (error) {
            showAxiosError(error);
        }
        this.setState({loading: false});
    }

    confirmActivePassive(item, activePassiveAction) {
        this.setState({
            selectedPrefix: item,
            confirmActivePassiveModal: true,
            activePassiveAction
        })
    }

    handleActivePassive = async () => {
        const {page, size, page2, size2} = this.state;
        if (!!this.state.selectedPrefix) {
            let params = {
                url: '/prefixCode/activePassivePrefix',
                method: "post",
                data: this.state.selectedPrefix
            };
            this.setState({loadingProcess: true});
            try {
                await request(params);
                this.setState({
                    selectedPrefix: null,
                    confirmActivePassiveModal: false,
                    activePassiveAction: null,
                    loadingProcess: false
                });
                this.listPrefixCodes(undefined, undefined, page, size);
                this.listBranchBasedPrefixList(undefined, undefined, page2, size2);
            } catch (error) {
                showAxiosError(error);
            }
            this.setState({loadingProcess: false});
        }
    }

    closeAddPrefixModal = () => {
        this.setState({addPrefixModal: false, manual: true})
    }
    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }
    searchPrefix = (name, value) => {
        let {branchPrefix, branchList, branchBasedPrefixList, newPrefixList} = this.state;
        branchPrefix[name] = value;
        if (name === "branchIndex") {
            branchPrefix.prefixType = null;
            branchPrefix.prefixIndex = null;
            let newPrefixList = branchBasedPrefixList.filter(item => {
                return item.branchName === branchList[value].branchName
            })
            this.setState({newPrefixList, prefixList: null})
        } else if (name == "prefixType") {
            branchPrefix.prefixIndex = null;
            if (branchPrefix.branchIndex != null && branchPrefix.prefixType != null) {
                newPrefixList = branchBasedPrefixList.filter(item => {
                    return item.branchName === branchList[branchPrefix.branchIndex].branchName
                })
            }
            newPrefixList = newPrefixList.filter(item => {
                return item.prefixCodeType === value
            })
            this.setState({newPrefixList, prefixList: null})
            this.getPrefix(value);
        }
        this.setState({branchPrefix})
    }
    cleanBranchPrefix = () => {
        let {branchPrefix, branchBasedPrefixList} = this.state;
        branchPrefix.branchIndex = null;
        branchPrefix.prefixIndex = null;
        branchPrefix.prefixType = null;
        this.setState({branchPrefix, newPrefixList: branchBasedPrefixList, prefixList: []});
    }

    render() {
        const {prefixCodes, branchBasedPrefixCode, newPrefixList, branchList, branchPrefix, prefixList} = this.state;
        const {branchIndex, prefixType, prefixIndex} = branchPrefix;

        const source = VirtualHost.conf.resourcePrefix;
        const types = [
            {value: "MVoucherPrefixCode", label: "Müstahsil Makbuzu"},
            {value: "SVoucherPrefixCode", label: "Serbest Meslek Makbuzu"},
            {value: "ExchangePrefixCode", label: "E-Döviz"},
            {value: 'PrefixCode', label: 'E-Fatura'},
            {value: 'EArsivPrefixCode', label: 'E-Arşiv'},
            {value: 'DespatchPrefixCode', label: 'E-İrsaliye'},
            {value: 'ReceiptAdvicePrefixCode', label: 'E-İrsaliye Yanıtı'},
            {value: 'ExpenseNotePrefixCode', label: 'E-Gider Pusulası'},
            {value: 'ReceiptPrefixCode', label: 'E-Adisyon Makbuzu'},
            {value: 'SigortaPrefixCode', label: 'E-Sigorta'}
        ];
        const columns = [
            {
                Header: "Belge Türü",
                title: "Belge Türü",
                accessor: "type",
                Cell: item => (
                    prefixTypeName(item.type)
                )
            },
            {
                Header: "Ön Ek",
                title: "Ön Ek",
                accessor: "key"
            },
            {
                Header: "İşlemler",
                title: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        {(VirtualHost.conf.resourcePrefix !== 'zirve' ||
                        (VirtualHost.conf.resourcePrefix === 'zirve' && this.props.currentUser.impersonate) ||
                        (EntegratorIdentifiers.ZIRVE === this.props.currentUser.vknTckn)) &&
                            <button type="button"
                                    onClick={() => this.confirmDelete(item, "mainPrefix")}
                                    data-toggle="tooltip" data-placement="bottom" title="Sil"
                                    style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
                                    rel="tooltip" className="Btn  btn-icon"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}>
                                <i className="BtnIcon far fa-trash-alt"/>
                            </button>
                        }
                        {VirtualHost.conf.resourcePrefix === 'zirve' &&
                            <button type="button"
                                    onClick={() => this.confirmActivePassive(item, item.deletedAt !== null ? "Aktif" : "Pasif")}
                                    data-toggle="tooltip" data-placement="bottom"
                                    title={item.deletedAt !== null ? "Aktif Et" : "Pasif Et"}
                                    style={item.deletedAt !== null ? {background: '#3fb0ac'} : {background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
                                    rel="tooltip" className="Btn  btn-icon"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}>
                                {item.deletedAt !== null ?
                                    <i className="BtnIcon fa fa-check"/>
                                    :
                                    <i className="BtnIcon fas fa-ban"/>
                                }
                            </button>
                        }
                    </div>
                )
            }
        ];
        if (VirtualHost.conf.resourcePrefix === 'zirve') {
            columns.splice(columns.length - 1, 0, {
                    Header: "Aktif/Pasif",
                    title: "Aktif/Pasif",
                    accessor: "deletedAt",
                    Cell: item => (
                        item.deletedAt !== null ? "Pasif" : "Aktif"
                    )
                }
            )
        }
        const columns2 = [
            {
                Header: "Şube Adı",
                title: "Şube Adı",
                accessor: "branchName",
                sortable: false
            },
            {
                Header: "Belge Türü",
                title: "Belge Türü",
                accessor: "prefixCodeType",
                sortable: false,
                Cell: item => (
                    prefixTypeName(item.prefixCodeType)
                )
            },
            {
                Header: "Ön Ek",
                title: "Ön Ek",
                accessor: "prefixCodeKey",
                sortable: false
            }, {
                Header: "İşlemler",
                title: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.confirmDelete(item, "customerBranchPrefix")}
                                data-toggle="tooltip" data-placement="bottom" title="Sil"
                                style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
                                rel="tooltip" className="Btn  btn-icon"
                                disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}>

                            <i className="BtnIcon far fa-trash-alt"/>
                        </button>
                    </div>
                )
            }
        ];
        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
                    <StickButton position="leftSide"
                                 className="stickButton plus-circle"
                                 onClick={() => this.setState({addPrefixModal: true})} label="Oluştur/Düzenle"/>
                </NavBarKS>
                <div className="row">
                    <div className="card-nav-tabs card-plain col-md-12">
                        <div className="card-header card-header-danger satirBasi">
                            {branchBasedPrefixCode &&
                                <div className="nav-tabs-navigation">
                                    <div className="nav-tabs-wrapper">
                                        <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'generalprefix' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('generalprefix')
                                                   }}
                                                   data-toggle="tab">Müşteri Ön Ekleri
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'branchprefix' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('branchprefix')
                                                   }}
                                                   data-toggle="tab">Şube Bazlı Ön Ekler</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="card-body">
                            <div className="tab-content">
                                <div
                                    className={"tab-pane " + (this.state.activeTab === 'generalprefix' ? 'active' : '')}
                                    id="generalprefix">
                                    <div className="col-sm-12">
                                        <div className="row baseDashboard">
                                            <div className="col-md-12">
                                                <div className="card-header ">
                                                    {!branchBasedPrefixCode &&
                                                        <h4 className="card-title">Müşteri Ön Ekleri</h4>
                                                    }
                                                </div>
                                                <div className="card-body">
                                                    <Table
                                                        loading={this.state.loading}
                                                        loadingText="Kayıtlar getiriliyor..."
                                                        content={prefixCodes}
                                                        total={this.state.total}
                                                        page={this.state.page}
                                                        manual={this.state.manual}
                                                        size={this.state.size}
                                                        options={["5", "10", "20", "50", "100"]}
                                                        columns={columns}
                                                        fetchData={this.listPrefixCodes}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"tab-pane " + (this.state.activeTab === 'branchprefix' ? 'active' : '')}
                                     id="branchprefix">
                                    <div className="col-sm-12">
                                        <div className="row baseDashboard">
                                            <div className="col-md-12 ">
                                                <div className="">
                                                    <div className="card-header ">
                                                        <div className="card-body"></div>
                                                        <div className="row card-body" style={{paddingTop: '20px'}}>
                                                            <div className="col-md-1" style={{paddingLeft: '0px'}}>
                                                                <label style={{
                                                                    textAlign: 'left',
                                                                    fontWeight: 'bold',
                                                                    paddingTop: '4px'
                                                                }}>Şube:</label>
                                                            </div>
                                                            <div className="col-md-2 mr-2">
                                                                <Select
                                                                    value={branchIndex}
                                                                    clearable={false}
                                                                    placeholder="Tümü"
                                                                    onChange={e => this.searchPrefix("branchIndex", e.value)}
                                                                    options={branchList && branchList.map((branch, index) => ({
                                                                        value: index,
                                                                        label: branch.branchName
                                                                    }))}
                                                                />
                                                            </div>
                                                            <div className="col-md-1" style={{paddingLeft: '0px'}}>
                                                                <label style={{
                                                                    textAlign: 'left',
                                                                    fontWeight: 'bold',
                                                                    paddingTop: '4px'
                                                                }}>Belge Türü:</label>
                                                            </div>
                                                            <div className="col-md-2 mr-2">
                                                                <Select
                                                                    value={prefixType}
                                                                    clearable={false}
                                                                    placeholder="Tümü"
                                                                    onChange={e => this.searchPrefix("prefixType", e.value)}
                                                                    options={types}
                                                                />
                                                            </div>
                                                            <div className="col-md-1" style={{paddingLeft: '0px'}}>
                                                                <label style={{
                                                                    textAlign: 'left',
                                                                    fontWeight: 'bold',
                                                                    paddingTop: '4px'
                                                                }}>Belge Ön Eki </label>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <Select
                                                                    disabled={prefixList == undefined ? true : false}
                                                                    value={prefixIndex}
                                                                    clearable={false}
                                                                    placeholder="Tümü"
                                                                    onChange={e => this.searchPrefix("prefixIndex", e.value)}
                                                                    options={prefixList && prefixList.length > 0 && prefixList.map((prefix, index) => ({
                                                                        value: index,
                                                                        label: prefix.key
                                                                    }))}
                                                                />
                                                            </div>
                                                            <div className="col-md-1" style={{paddingLeft: '0px'}}>
                                                                <button type="button"
                                                                        onClick={e => {
                                                                            this.saveBranchPrefix()
                                                                        }}
                                                                        data-toggle="tooltip" data-placement="bottom"
                                                                        title="Ekle"
                                                                        style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                                                        rel="tooltip" className="Btn  btn-icon"
                                                                        disabled={prefixIndex == null || branchIndex == null || this.state.loading == true}>

                                                                    <i style={{fontSize: "0.9rem"}}
                                                                       className="BtnIcon fa fa-plus"/>
                                                                </button>
                                                                <button type="button"
                                                                        onClick={e => {
                                                                            this.cleanBranchPrefix()
                                                                        }}
                                                                        data-toggle="tooltip" data-placement="bottom"
                                                                        title="Temizle"
                                                                        style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
                                                                        rel="tooltip" className="Btn  btn-icon"
                                                                        disabled={prefixIndex == null && branchIndex == null && prefixType == null}>
                                                                    <i style={{fontSize: "0.9rem"}}
                                                                       className="BtnIcon fa fa-trash-alt"/>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <Table
                                                            loading={this.state.loading2}
                                                            loadingText="Kayıtlar getiriliyor..."
                                                            content={newPrefixList}
                                                            topPagination={false}
                                                            total={this.state.total2}
                                                            page={this.state.page2}
                                                            size={this.state.size2}
                                                            options={["5", "10", "20", "50", "100"]}
                                                            columns={columns2}
                                                            fetchData={this.listBranchBasedPrefixList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Modal isOpen={this.state.addPrefixModal} size="lg">
                    <ModalHeader toggle={this.closeAddPrefixModal}>Ön Ek Düzenle</ModalHeader>
                    <ModalBody>
                        <PrefixCodeModal currentUser={this.props.currentUser}/>
                    </ModalBody>
                    <ModalFooter>

                        <div className="col-sm-12 row">
                            <div className="col-3 ">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '10px 54px 10px 23px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec btn-icon"
                                        onClick={this.closeAddPrefixModal}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6 "></div>

                            <div className="col-3 ">

                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '10px 54px 10px 23px',
                                            float: 'right'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet btn-icon"
                                        onClick={() => this.setState({addPrefixModal: false, manual: true})}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.confirmDeleteModal}>
                    <ModalHeader/>
                    <ModalBody>
                        Silmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={() => this.setState({
                                            confirmDeleteModal: false,
                                            selectedPrefix: null
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6"></div>

                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}
                                        onClick={() => this.handleDelete()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.confirmActivePassiveModal}>
                    <ModalHeader/>
                    <ModalBody>
                        {this.state.activePassiveAction} etmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={() => this.setState({
                                            confirmActivePassiveModal: false,
                                            selectedPrefix: null
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6"></div>

                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        disabled={(!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser) || this.state.loadingProcess)}
                                        onClick={() => this.handleActivePassive()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default PrefixCode;